import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import WorkflowHero from './components/WorkflowHero';
import WorkflowOverview from './components/WorkflowOverview';
import WorkflowBenefits from './components/WorkflowBenefits';
import WorkflowProcess from './components/WorkflowProcess';
import WorkflowSolutions from './components/WorkflowSolutions';
import WorkflowCaseStudies from './components/WorkflowCaseStudies';
import WorkflowCTA from './components/WorkflowCTA';

export default function DocumentWorkflowConsultingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <WorkflowHero />
        <WorkflowOverview />
        <WorkflowBenefits />
        <WorkflowProcess />
        <WorkflowSolutions />
        <WorkflowCaseStudies />
        <WorkflowCTA />
      </main>
      <Footer />
    </div>
  );
}
